// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"e2e8a714","973":"de1e3993"}[chunkId] + ".chunk.css";
};